<h1 mat-dialog-title class="titulo">
  <mat-icon color="warn">report_problem</mat-icon>
  Hay cambios sin guardar
</h1>
<mat-divider></mat-divider>

<div mat-dialog-content class="contenido">
  <p>Si salís ahora se pierden las modificaciones que hiciste en esta pantalla.</p>
</div>

<mat-divider></mat-divider>

<div mat-dialog-actions class="acciones">
  <!-- Quedarse es la opción segura, así que es la destacada -->
  <button mat-flat-button color="primary" (click)="quedarse()" cdkFocusInitial>
    <mat-icon>edit</mat-icon>
    Seguir editando
  </button>

  <button mat-button color="warn" (click)="salir()">
    Salir sin guardar
  </button>
</div>
